import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { guestGuard } from '@core/guards/guest.guard';

export const routes: Routes = [
  // Auth layout (sin sidebar)
  {
    path: '',
    loadComponent: () => import('@layout/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () => import('@features/auth/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('@features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
      },
      {
        path: 'reset-password',
        loadComponent: () => import('@features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
      },
      {
        path: 'compra-plan',
        loadComponent: () => import('@features/planes/pages/compra-plan/compra-plan.component').then(m => m.CompraPlanComponent),
        title: 'Comprar Plan',
      },
      {
        path: 'compra-plan-response',
        loadComponent: () => import('@features/planes/pages/compra-plan-response/compra-plan-response.component').then(m => m.CompraPlanResponseComponent),
        title: 'Confirmando Pago',
      },
      {
        path: 'compra-plan-cancelar',
        loadComponent: () => import('@features/planes/pages/compra-plan-cancelar/compra-plan-cancelar.component').then(m => m.CompraPlanCancelarComponent),
        title: 'Pago Cancelado',
      },
      {
        path: 'solicitud-firma-response',
        loadComponent: () => import('@features/solicitud-firma/pages/solicitud-firma-response/solicitud-firma-response.component').then(m => m.SolicitudFirmaResponseComponent),
        title: 'Confirmando Pago',
      },
      {
        path: 'solicitud-firma-cancelar',
        loadComponent: () => import('@features/solicitud-firma/pages/solicitud-firma-cancelar/solicitud-firma-cancelar.component').then(m => m.SolicitudFirmaCancelarComponent),
        title: 'Pago Cancelado',
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },

  // Main layout (con sidebar, protegido)
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('@layout/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('@features/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'perfil',
        loadComponent: () => import('@features/perfil/perfil.component').then(m => m.PerfilComponent),
        title: 'Mi Perfil',
      },
      {
        path: 'solicitud-firma',
        loadComponent: () => import('@features/solicitud-firma/pages/solicitud-firma/solicitud-firma.component').then(m => m.SolicitudFirmaComponent),
        title: 'Solicitud de Firma Electrónica',
      },
      {
        path: 'facturacion',
        loadChildren: () => import('@features/facturacion/facturacion.routes').then(m => m.facturacionRoutes),
      },
      {
        path: 'clientes',
        loadChildren: () => import('@features/clientes/clientes.routes').then(m => m.clientesRoutes),
      },
      {
        path: 'proveedores',
        loadChildren: () => import('@features/proveedores/proveedores.routes').then(m => m.proveedoresRoutes),
      },
      {
        path: 'inventario',
        loadChildren: () => import('@features/inventario/inventario.routes').then(m => m.inventarioRoutes),
      },
      {
        path: 'compras',
        loadChildren: () => import('@features/compras/compras.routes').then(m => m.comprasRoutes),
      },
      {
        path: 'admin',
        loadChildren: () => import('@features/admin/admin.routes').then(m => m.adminRoutes),
      },
      {
        path: 'contabilidad',
        loadChildren: () => import('@features/contabilidad/contabilidad.routes').then(m => m.contabilidadRoutes),
      },
      {
        path: 'ats',
        loadChildren: () => import('@features/ats/ats.routes').then(m => m.atsRoutes),
      },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
